import './style/index.js';

import _Dropdown from './dropdown';

export type { DropdownProps } from './dropdown';
export * from './type';

export const Dropdown = _Dropdown;

export default Dropdown;
